export default {
  getPhoneLink(phone) {
    return "tel:" + phone.replace(/[^0-9+]/g, "");
  },

  handleScroll: function(evt, el) {
    if (el.getBoundingClientRect().y < window.innerHeight + 40) {
      // el.setAttribute("style", "animation: showUp 1s forwards;");
      el.classList.add("show-up");
    }
  },
  scrollElementToTop(scroller) {
    let offset = { top: 0, left: 0 };
    (function smoothscroll() {
      var currentScroll = scroller.scrollTop;
      if (currentScroll > offset.top) {
        window.requestAnimationFrame(smoothscroll);
        scroller.scrollTo(
          0,
          (currentScroll - currentScroll / 5).clamp(
            offset.top,
            Number.MAX_VALUE
          )
        );
      }
    })();
  },
  scrollToTop() {
    let el = document.getElementById("main-banner");
    let offset = this.getOffset(el);
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > offset.top) {
        window.requestAnimationFrame(smoothscroll);

        window.scrollTo(
          0,
          (currentScroll - currentScroll / 5).clamp(
            offset.top,
            Number.MAX_VALUE
          )
        );
      }
    })();
  },
  animating: false,
  scrollTo(el) {
    if (!this.animating) {
      this.animating = true;
      let offset = this.getOffset(el);
      let start = document.documentElement.scrollTop || document.body.scrollTop;
      let end = offset.top - 84;
      let currentFrame = 0;
      let smoothscroll = () => {
        if (currentFrame < 60) {
          window.requestAnimationFrame(smoothscroll);
          currentFrame++;
          var t = currentFrame / 60;
          window.scrollTo(0, start + this.easeInOut(t) * (end - start));
        } else {
          this.animating = false;
        }
      };
      smoothscroll();
    }
  },
  scrollToPosition(position, frames = 60) {
    if (!this.animating) {
      this.animating = true;
      let start = document.documentElement.scrollTop || document.body.scrollTop;
      let end = position.y;
      let currentFrame = 0;
      let smoothscroll = () => {
        if (currentFrame < frames) {
          window.requestAnimationFrame(smoothscroll);
          currentFrame++;
          var t = currentFrame / frames;
          window.scrollTo(
            0,
            start + (this.easeInOut(t) * (end - start)).clamp(0, position.y)
          );
        } else {
          this.animating = false;
        }
      };
      smoothscroll();
    }
  },
  easeInOut(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
    };
  },
  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },
  parseDateFormat(dateString) {
    let date = new Date(dateString);
    return date.toLocaleString("ru", {
      month: "long",
      day: "numeric",
      year: date.year === new Date().year ? undefined : "numeric",
      hour: "numeric",
      minute: "numeric",
    });
  },
  parseDate(dateString) {
    let date = new Date(dateString);
    return date
      .toLocaleString("ru", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
      .replace("г.", "");
  },
  copyToClipboard(valueForClipboard) {
    const isIOS = navigator.userAgent.match(/ipad|ipod|iphone/i);
    const textArea = document.createElement("textarea");
    textArea.value = valueForClipboard;

    textArea.style.position = "absolute";
    textArea.style.left = "-9999px"; // to make it invisible and out of the reach
    textArea.setAttribute("readonly", ""); // without it, the native keyboard will pop up (so we show it is only for reading)

    document.body.appendChild(textArea);

    if (isIOS) {
      const range = document.createRange();
      range.selectNodeContents(textArea);

      const selection = window.getSelection();
      selection.removeAllRanges(); // remove previously selected ranges
      selection.addRange(range);
      textArea.setSelectionRange(0, valueForClipboard.length); // this line makes the selection in iOS
    } else {
      textArea.select(); // this line is for all other browsers except ios
    }

    try {
      return document.execCommand("copy"); // if copy is successful, function returns true
    } catch (e) {
      return false; // return false to show that copy unsuccessful
    } finally {
      document.body.removeChild(textArea); // delete textarea from DOM
    }
  },
  css_browser_selector(u) {
    var ua = u.toLowerCase(),
      is = function(t) {
        return ua.indexOf(t) > -1;
      },
      g = "gecko",
      w = "webkit",
      s = "safari",
      o = "opera",
      m = "mobile",
      h = document.documentElement,
      b = [
        !/opera|webtv/i.test(ua) && /msie\s(\d)/.test(ua)
          ? "ie ie" + RegExp.$1
          : is("firefox/2")
          ? g + " ff2"
          : is("firefox/3.5")
          ? g + " ff3 ff3_5"
          : is("firefox/3.6")
          ? g + " ff3 ff3_6"
          : is("firefox/3")
          ? g + " ff3"
          : is("gecko/")
          ? g
          : is("opera")
          ? o +
            (/version\/(\d+)/.test(ua)
              ? " " + o + RegExp.$1
              : /opera(\s|\/)(\d+)/.test(ua)
              ? " " + o + RegExp.$2
              : "")
          : is("konqueror")
          ? "konqueror"
          : is("blackberry")
          ? m + " blackberry"
          : is("android")
          ? m + " android"
          : is("chrome")
          ? w + " chrome"
          : is("iron")
          ? w + " iron"
          : is("applewebkit/")
          ? w + " " + s + (/version\/(\d+)/.test(ua) ? " " + s + RegExp.$1 : "")
          : is("mozilla/")
          ? g
          : "",
        is("j2me")
          ? m + " j2me"
          : is("iphone")
          ? m + " iphone"
          : is("ipod")
          ? m + " ipod"
          : is("ipad")
          ? m + " ipad"
          : is("mac")
          ? "mac"
          : is("darwin")
          ? "mac"
          : is("webtv")
          ? "webtv"
          : is("win")
          ? "win" + (is("windows nt 6.0") ? " vista" : "")
          : is("freebsd")
          ? "freebsd"
          : is("x11") || is("linux")
          ? "linux"
          : "",
        "js",
      ];
    var c = b.join(" ");
    return c;
  },
};
